<template>
    <v-app>
        <navigator :conditions="conditions" 
            :isFiltering="filterling"
            @toggle-is-dark="toggleIsDark"
            @toggle-discount="toggleDiscount"
            @toggle-gamepass="toggleGamePass"
            @toggle-eaplay="toggleEaPlay"
            @change-store="changeStore"
            @change-priority="changePriority"
            @toggle-screen="toggleScreen"
            @toggle-history="toggleHistory"
            @open-bottom-searcher="openBottomSearcher" />

        <v-main>
            <v-container class="fill-height">
                <v-row ref="container">
                    <v-col v-if="paginatedIndex > 0" cols="12">
                        <v-alert type="info" border="left" dense text class="game-notifier">{{ notifierText }}</v-alert>
                    </v-col>
                    <v-col v-for="game in paginateGames" :key="game.bid" cols="12" sm="6">
                        <game-card :game="game" :conditions="conditions" :locale="locale" @open-details="openDetailsDialog"/>
                    </v-col>
                    <v-col cols="12" v-if="finishPaginated == false && games.length - paginatedIndex > 0">
                        <div class="text-center">
                            <v-btn rounded color="red" dark @click="onMoreGames" class="more">More</v-btn>
                        </div>
                    </v-col>
                    <v-col v-if="loading" cols="12">
                        <div class="text-center">
                            <v-progress-linear v-model="loadingPercent" height="25" color="light-green darken-4" reactive>
                                <strong>{{ loadingPercent }}%</strong>
                            </v-progress-linear>
                        </div>
                    </v-col>
                </v-row>
                
                <game-details :game="selectedGame" :openDetails="openDetails" :locale="locale" @close-details="closeDetails" />
            </v-container>
        </v-main>
        
        <bottom-searcher :searcher="searcher" :filteredGames="filteredGames" :games="games" @close-bottom-searcher="closeBottomSearcher" />
    </v-app>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
// import 'moment/locale/en-au'
import 'moment/locale/ko'
import numeral from 'numeral'
import CryptoJS from 'crypto-js'
import pako from 'pako'

import Navigator from './Navigator'
import GameCard from './GameCard'
import GameDetails from './GameDetails'
import BottomSearcher from './BottomSearcher'

const locale = 'ko-kr'
// const locale = 'en-us'

const SECRET_KEY = 'XbOx-ShOpPeR-kEy'
const SORT_ORDER = {
    'NONE': () => {
        return 0
    },
    'PRICE': (prev, next) => {
        if (prev.curPrice > next.curPrice) return 1
        else if (prev.curPrice < next.curPrice) return -1
        else return 0
    },
    'PERCENT': (prev, next) => {
        let prevPercent = prev.curPrice / prev.oriPrice
        let nextPercent = next.curPrice / next.oriPrice
        if (prevPercent < nextPercent) return -1;
        else if (prevPercent > nextPercent) return 1;
        else return 0
    }
}
const { XBOX_SHOPPER_STORE_V1 } = localStorage
const PAGINATED_SCOPE = 50

export default {
    name: 'XboxShopper',
    created () {
        this.$vuetify.theme.dark = true

        if (!_.isEmpty(XBOX_SHOPPER_STORE_V1)) {
            let store = JSON.parse(CryptoJS.AES.decrypt(XBOX_SHOPPER_STORE_V1, SECRET_KEY).toString(CryptoJS.enc.Utf8))
            if (store.sortPriority !== undefined) this.conditions.sortPriority = store.sortPriority
            if (store.history !== undefined) this.conditions.history = store.history
            if (store.screen !== undefined) this.conditions.screen = store.screen
        }
        this.fetchGames().then(() => {
            setInterval(() => {
                let updateDateTime = moment(this.updateDate, 'YYYY-MM-DD HH:mm:ss').format('YYYYMMDD')
                if (moment().format('YYYYMMDD') != updateDateTime) {
                    console.log('current date: ', moment().format('YYYYMMDD'), 'fetch date: ', updateDateTime)
                    this.fetchGames()
                }
            }, 10000)
        })
    },
    data: () => ({
        locale,
        dialog: false,

        notifier: false,
        isDiscountOnly: true,
        isGamePassOnly: false,
        isEaPlayOnly: false,

        loading: true,
        loaded: 0,
        totalLoaded: 100,

        updateDate: '',
        rawGames: [],
        selectedGame: {},
        paginatedIndex: 0,
        finishPaginated: false,

        conditions: {
            locale,
            searchText: '',
            categories: [],
            priceRange: [],
            sortPriority: 'NONE',
            screen: true,
            history: false,
        },

        openDetails: false,
        searcher: false
    }),
    computed: {
        filterling () {
            return !_.isEmpty(this.conditions.searchText) && !_.isEmpty(this.conditions.categories)
        },
        baseGames () {
            console.log(this.rawGames)
            return this.rawGames
                // .filter(game => game.isOnSale == true)
                    // && game.releaseDate != 'Invalid date'
                    // && !isNaN(game.releaseDate.replace(/-/g, '')))
                    /*
                .map(({ nsuid, categories, title, price, releaseDate, boxArt, slug, salesStatus, discounts = [], numberOfPlayers, covers, screens, hero }) => {
                    let _categories = Array.isArray(categories) ? categories : [ categories ]
                    let categoryText = _categories.join(', ')
                    let game = {
                        nsuid, title, price, releaseDate, boxArt, slug, salesStatus, discounts, numberOfPlayers, covers, screens, hero,
                        categoryText, 
                        categories: _categories, 
                        gameArt: (!!covers && !!covers.mobile) ? covers.mobile : boxArt,
                        isDiscountPresent: false,
                        currentPrice: price,
                        currentPriceText: numeral(price).format('0.00'),
                        percent: 100,
                        percentText: '100.0',
                        dayLeft: '', 
                        dayLeftDiff: 0,
                        discountPeriod: 0
                    }

                    if (discounts.length > 0) {
                        let { [discounts.length - 1] : recentlyDiscount } = discounts
                        let dayLeftDiff = new Date().getTime() - moment(recentlyDiscount.endDateTime, 'YYYY-MM-DD HH:mm:ss').add(TIME_DIFF, 'hours').toDate().getTime()
                        if (dayLeftDiff < 0) {
                            let dayLeft = moment(recentlyDiscount.endDateTime, 'YYYY-MM-DD HH:mm:ss').add(TIME_DIFF, 'hours').fromNow()
                            let discountPeriod = moment(recentlyDiscount.startDateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ~ ' +
                                moment(recentlyDiscount.endDateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
                            game = {
                                ...game,
                                isDiscountPresent: true,
                                currentDiscount: {...recentlyDiscount},
                                currentPrice: recentlyDiscount.price,
                                currentPriceText: numeral(recentlyDiscount.price).format('0.00'),
                                percent: (1 - recentlyDiscount.price / price) * 100,
                                percentText: numeral((1 - recentlyDiscount.price / price) * 100).format('0'),        
                                dayLeft, 
                                dayLeftDiff,
                                discountPeriod
                            }
                        } 
                    }
                    return game
                })
                */
        },
        filteredGames () {
            return this.baseGames
                .filter(game => {
                    if (this.isDiscountOnly && !game.isOnSale) return false
                    else return true
                })
                .filter(game => {
                    if (this.isGamePassOnly && !game.isGamePass) return false
                    else return true
                })
                .filter(game => {
                    if (this.isEaPlayOnly && !game.isEaPlay) return false
                    else return true
                })
        },
        games () {
            return this.filteredGames.filter(game => { 
                let present = true
                if (this.conditions.searchText.length > 0) {
                    let title = game.title || ''
                    // let categoryText = game.categoryText || ''
                    present = title.toUpperCase().indexOf(this.conditions.searchText.toUpperCase()) > -1
                        // || categoryText.toUpperCase().indexOf(that.conditions.searchText.toUpperCase()) > -1
                    
                    if (!present) return false
                }
                if (this.conditions.categories.length > 0) {
                    present = _.intersection(game.genres, this.conditions.categories).length > 0
                    if (!present) return false
                }
                if (this.conditions.priceRange.length == 2) {
                    present = (game.curPrice >= this.conditions.priceRange[0] && game.curPrice <= this.conditions.priceRange[1])
                    if (!present) return false
                }
                return present
            }).sort(SORT_ORDER[this.conditions.sortPriority])

        },
        paginateGames () {
            return this.games.slice(0, this.paginatedIndex)
        },
        updateDateText () {
            return this.updateDate !== '' ? moment(this.updateDate, 'YYYY-MM-DD HH:mm:ss').fromNow() : ''
        },
        notifierText () {
            let count = numeral(this.games.length).format('#,##0')
            return this.$t('main-msg-games-count', 1, { count, updateDateText: this.updateDateText })
        },
        loadingPercent () {
            return Math.ceil(this.loaded / this.totalLoaded * 100)
        }
    },
    methods: {
        fetchGames () {
            console.log('call fetchGames...')
            let that = this
            return new Promise(resolve => {
                axios.get(`/data/games-${this.locale}?p=${moment().format('YYYYMMDDHHmmss')}`, {
                    headers: {
                        'Content-Type': 'text/plain',
                        'Accept': 'text/plain',
                    },
                    onDownloadProgress (event) {
                        that.loaded = event.loaded
                        that.totalLoaded = event.total
                    }
                }).then(result => {
                    that.loaded = 100
                    that.totalLoaded = 100
                    setTimeout(() => {
                        let data = JSON.parse(
                            pako.inflate(
                                CryptoJS.AES.decrypt(result.data, SECRET_KEY).toString(CryptoJS.enc.Utf8), 
                                {to: 'string'}
                            )
                        )
                        
                        that.updateDate = data.updateDate
                        that.rawGames = data.games
                        that.paginatedIndex = PAGINATED_SCOPE
                        that.loading = false
                        resolve()
                    }, 300)
                })
            })
        },
        initPaginate () {
            window.scrollTo(0, 0)
            this.paginatedIndex = PAGINATED_SCOPE
            this.finishPaginated = false
        },
        openDetailsDialog (game) {
            this.selectedGame = game
            this.openDetails = true
        },
        closeDetails () {
            this.openDetails = false
        },
        toggleIsDark (isDark) {
            this.triggerGaEvent('changeIsDark', 'change', isDark)
        },
        toggleDiscount (isDiscountOnly) {
            this.initPaginate()
            this.isDiscountOnly = isDiscountOnly
            this.triggerGaEvent('changeDiscount', 'change', isDiscountOnly)
        },
        toggleGamePass (isGamePassOnly) {
            this.initPaginate()
            this.isGamePassOnly = isGamePassOnly
            this.triggerGaEvent('changeGamePass', 'change', isGamePassOnly)
        },
        toggleEaPlay (isEaPlayOnly) {
            this.initPaginate()
            this.isEaPlayOnly = isEaPlayOnly
            this.triggerGaEvent('changeEaPlay', 'change', isEaPlayOnly)
        },
        changeStore (locale) {
            this.locale = locale
            this.initPaginate()
            this.fetchGames()
        },
        changePriority (sort) {
            this.initPaginate()
            this.conditions.sortPriority = sort
            this.saveStore()
            this.triggerGaEvent('changePriority', 'change', sort)
        },
        toggleScreen (screen) {
            this.conditions.screen = screen
            this.saveStore()
            this.triggerGaEvent('changeScreen', 'change', screen ? 'SCREEN_ON' : 'SCREEN_OFF')
        },
        toggleHistory (history) {
            this.conditions.history = history
            this.saveStore()
            this.triggerGaEvent('changeHistory', 'change', history ? 'HISTORY_ON' : 'HISTORY_OFF')
        },
        openBottomSearcher () {
            this.searcher = true
        },
        closeBottomSearcher (conditions) {
            this.searcher = false
            this.conditions.searchText = conditions.searchText
            this.conditions.categories = conditions.categories
            this.conditions.priceRange = conditions.priceRange
            this.initPaginate()
        },
        onMoreGames () {
            if (!this.finishPaginated) {
                this.paginatedIndex += PAGINATED_SCOPE

                if (this.games.length !== 0 && this.paginatedIndex > this.games.length) {
                    this.finishPaginated = true
                }
            }
        },
        saveStore () {
            localStorage.setItem('XBOX_SHOPPER_STORE_V1', CryptoJS.AES.encrypt(
                JSON.stringify({
                    sortPriority: this.conditions.sortPriority,
                    screen: this.conditions.screen,
                    history: this.conditions.history
                }), SECRET_KEY).toString())
        },
        triggerGaEvent (category, action, label, value) {
            console.log(category, action, label, value)
            /*
            return new Promise((resolve) => {
                this.$gtag.event({
                    eventCategory: category, 
                    eventAction: action, 
                    eventLabel: label,
                    eventValue: _.isEmpty(value) ? undefined : value,
                    hitCallback () {
                        return resolve()
                    }
                })
            })
            */
        }
    },
    components: {
        'navigator': Navigator,
        'game-card': GameCard,
        'game-details': GameDetails,
        'bottom-searcher': BottomSearcher,
    }
};
</script>

<style scoped>
.game-notifier {
    margin-bottom: 0px !important;
}
.more {
    margin-top: 15px;
}
</style>